import React from 'react'
import cx from 'classnames'

import Spin from 'src/components/Spin'
import styles from './styles.module.less'

export default ({ styleVariation, addDesktopBackgroundColor, className, ...rest }) => {
  const classNames = cx({
    [styles.spinner]: true,
    [styles.staticWithHeight]: styleVariation && styleVariation === 'staticWithHeight',
    [styles.desktopBackgroundColor]: addDesktopBackgroundColor,
    [className]: !!className
  })


  return (
    <div data-cy="loader" className={classNames} {...rest}>
      <Spin />
    </div>
  )
}
